import React from 'react'
import './automatization.style.scss'

function Automatization() {
    return (
        <div className='automatization'>Automatization</div>
    )
}

export default Automatization